/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Sort_RegistrationInputs */



/**
* | output |
* | --- |
* | "Registration order" |
*
* @param {Players_Sort_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_sort_registration = /** @type {((inputs?: Players_Sort_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Sort_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ordre d'inscription")
	if (locale === "es") return /** @type {LocalizedString} */ ("Orden de inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ordem de inscrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordine di iscrizione")
	return /** @type {LocalizedString} */ ("Registration order")
});